module.exports = __webpack_public_path__ + "static/media/uber.0f627048.jpg";